let list = [];

for (let i = 0; i < 15; i++) {
    list.push({
        id: i + 1,
        name: '纺织001',
        level: [1, 2, 3][parseInt(Math.random() * 3)],
        content: '设备温度再开启状态下设备温度再开启状态下'
    })
}

export default list;



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/querySsgjList.js